import './text-link-icon.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import styles from './text-link-icon.module.scss.js';

const TextLinkIcon = (props) => {
    const { children, renderIcon, iconPosition = 'right', surface = 'lightPrimary', tabIndex = 0, href, onClick, onKeyDown, ariaLabel, 'aria-label': ariaLabelValue, 'data-testid': testId = 'text-link-icon' } = props, rest = __rest(props, ["children", "renderIcon", "iconPosition", "surface", "tabIndex", "href", "onClick", "onKeyDown", "ariaLabel", 'aria-label', 'data-testid']);
    const textLinkIconStyles = [
        styles.textLinkIcon,
        styles[surface.toLowerCase()],
    ];
    const _onKeyDown = (e) => {
        if (onKeyDown)
            onKeyDown(e);
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
            e.preventDefault();
            e.target.click();
        }
    };
    const _onClick = (e) => {
        // reassign the target due to the hit area propogation
        const newEvent = e;
        newEvent.target = e.currentTarget;
        /* istanbul ignore else */
        if (onClick)
            return onClick(newEvent);
    };
    const getIconColor = () => surface.includes('dark')
        ? 'var(--vds-color-element-primary-onlightprimary)'
        : 'var(--vds-color-element-primary-ondarkprimary)';
    const _renderIcon = () => {
        if (!renderIcon) {
            return null;
        }
        const IconComponent = renderIcon({
            size: '12px',
            color: getIconColor(),
        });
        return IconComponent;
    };
    const Element = href ? 'a' : 'button';
    if (Element === 'a')
        textLinkIconStyles.push(styles.anchor);
    return (jsx(Element, { href: href, className: textLinkIconStyles.join(' '), tabIndex: tabIndex, onKeyDown: _onKeyDown, onClick: _onClick, "aria-label": ariaLabelValue || ariaLabel || '', "data-testid": testId, "data-analyticstrack": rest['data-analyticstrack'], "data-track": rest['data-track'], "data-track-ignore": rest['data-track-ignore'], "data-clickstream": rest['data-clickstream'], "data-sitecat-cta": rest['data-sitecat-cta'], "data-sitecat-datatrack": rest['data-sitecat-datatrack'], "data-sitecat-position": rest['data-sitecat-position'], "data-sitecat-level": rest['data-sitecat-level'], children: jsxs("div", { className: styles.link, children: [iconPosition === 'left' && _renderIcon(), jsx("span", { children: children }), iconPosition === 'right' && _renderIcon()] }) }));
};

export { TextLinkIcon as default };
